export default __webpack_public_path__ + "static/media/TV_bold.f8ba024f.svg";